<template>
  <div v-if="tutorial" class="tutorial-modal-backdrop" @click.self="$emit('close')">
    <div class="tutorial-modal" role="dialog" aria-modal="true" :aria-label="tutorial.title">
      <header class="flex items-center justify-between">
        <h3 class="font-semibold">{{ tutorial.title }}</h3>
        <button type="button" @click="$emit('close')" aria-label="Close">✕</button>
      </header>
      <p v-if="failed" class="p-4 text-sm">This tutorial isn’t available yet. Please check back soon.</p>
      <video
        v-else
        controls
        preload="none"
        :poster="tutorial.poster"
        :src="tutorial.src"
        class="w-full"
        @error="failed = true"
      ></video>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from "vue";
import { Tutorial } from "/@/config/tutorials";

export default defineComponent({
  name: "TutorialModal",
  props: { tutorial: { type: Object as PropType<Tutorial | null>, default: null } },
  emits: ["close"],
  setup(props) {
    const failed = ref(false);
    watch(() => props.tutorial, () => { failed.value = false; }); // reset on open/switch
    return { failed };
  },
});
</script>

<style lang="postcss" scoped></style>
